export default __webpack_public_path__ + "static/media/phreportable.e21ea969.pdf";